import React, { Component } from "react";
import { Field } from "redux-form";
import FieldValidationContext from "../../../Context/FieldValidationContext";

export default class ValidatedField extends Component {

    render() {
        const { children, name, container, ...props } = this.props;
        const Component = container ? container : Field;
        return (
            <FieldValidationContext.Consumer>
                {validity => (
                    <Component
                        validity={validity[name]}
                        name={name}
                        {...props}
                    >
                        {children}
                    </Component>
                )}
            </FieldValidationContext.Consumer>
        );
    }

}